import { Box } from "@mui/material";
import EkhoolImage from "../ekhoolImage/ekhoolImage";

export default function StackImage({ src, view, onClick }) {
    const offset = 6;

    return (
        <Box
            onClick={onClick}
            sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                cursor: "pointer",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: -offset * 2,
                    left: -offset * 2,
                    width: "100%",
                    height: "100%",
                    bgcolor: "#ddd",
                    borderRadius: 1,
                    zIndex: 0,
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    top: -offset,
                    left:-offset,
                    width: "100%",
                    height: "100%",
                    bgcolor: "#ccc",
                    borderRadius: 1,
                    zIndex: 1,
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    top:0,
                    left:0,
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    borderRadius: 1,
                    zIndex: 2,
                }}
            >
                <EkhoolImage
                    src={src}
                    objectFit="cover"
                    style={{ width: "100%", height: "100%" }}
                />
            </Box>
        </Box>
    );
}
